<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("Configuration CEE") }}</h1>
      <b-button 
        size="sm"
        variant="success"
        class="button-succes-style ml-2 float-right mb-2"
        @click="openCreateModal"
      >
        <font-awesome-icon icon="plus-circle" /> {{ $t("NEW") }}
      </b-button>
      <b-button 
        size="sm"
        variant="danger" 
        @click="goBack"
        class="button-succes-style"
      >
        <font-awesome-icon icon="arrow-left" /> {{ $t("Retour") }}
      </b-button>
    </div>

    <div class="content">
      <div class="filtre">
        <p class="table-count">{{ getAllConfigurations ? getAllConfigurations.length : 0 }} {{ $t("Configurations") }}</p>
      </div>
      <div class="table-rapport-style w-100">
        <div v-if="getLoadingConfiguration" class="text-center p-4">
          <b-spinner variant="primary" label="Chargement..."></b-spinner>
          <p class="mt-2">{{ $t("Chargement des configurations...") }}</p>
        </div>
        <table v-else>
          <thead>
            <tr>
              <th style="border-radius: 5px 0px 0px 0px">{{ $t("Nom de configuration") }}</th>
              <th>{{ $t("Type prix") }}</th>
              <th>{{ $t("Date début") }}</th>
              <th>{{ $t("Date fin") }}</th>
              <th style="border-radius: 0px 5px 0px 0px" class="action_head">{{ $t("Actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="operation in getAllConfigurations" 
              :key="operation.id"
              role="row"
              class="ligneNormale"
            >
              <td aria-colindex="1" role="cell">{{ operation.label }}</td>
              <td aria-colindex="2" role="cell">{{ operation.type_prix }}</td>
              <td aria-colindex="3" role="cell">{{ formatDate(operation.date_debut) }}</td>
              <td aria-colindex="4" role="cell">{{ formatDate(operation.date_fin) }}</td>
              <td aria-colindex="5" role="cell" class="action_col">
                <b-button 
                  v-if="operation.type_prix === 'pourcentage'"
                  variant="link" 
                  size="sm" 
                  @click="goToPrecarite(operation)"
                  class="mr-2 p-0"
                >
                  <font-awesome-icon icon="home" style="color: blue;" />
                </b-button>
                <b-button 
                  variant="link" 
                  size="sm" 
                  @click="openEditModal(operation)"
                  class="mr-2 p-0"
                >
                  <font-awesome-icon icon="edit" style="color: green;" />
                </b-button>
                <b-button 
                  variant="link" 
                  size="sm" 
                  @click="confirmDelete(operation)"
                  class="p-0"
                >
                  <font-awesome-icon icon="trash" style="color: red;" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Create/Update -->
    <b-modal 
      v-model="showModal" 
      :title="isEdit ? $t('Modifier') : $t('Créer') + ' ' + $t('Configuration CEE')"
      size="md"
    >
      <b-form @submit.prevent="saveOperation">
        <div class="card p-2">
          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Opération CEE')">
                <multiselect
                  v-model="selectedTypeDevis"
                  :options="typeDevisOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :searchable="true"
                  :limit="2"
                  :limitText="getLimitText"
                  label="text"
                  track-by="value"
                  :placeholder="$t('Sélectionner les opérations')"
                  class="form-input custom-placeholder custom-input multiselect-operations"
                >
                  <template slot="noResult">
                    {{ $t("Aucun résultat trouvé") }}
                  </template>
                </multiselect>
              </b-form-group>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Label')">
                <b-form-input v-model="form.label" />
                <div v-if="erreurlist.label" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.label)">
                    <span v-for="(e, index) in erreurlist.label" :key="index">
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.label }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Version')">
                <b-form-input v-model="form.version" />
              </b-form-group>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Volume Cumac')">
                <b-form-input v-model="form.volume_cumac" type="number" />
              </b-form-group>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Type Prix')">
                <b-form-select v-model="form.type_prix" :options="typePrixOptions" />
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Date Début')">
                <b-form-input v-model="form.date_debut" type="date" />
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Date Fin')">
                <b-form-input v-model="form.date_fin" type="date" />
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('Actif')">
                <b-form-checkbox v-model="form.active" switch>
                  {{ form.active ? $t('Activé') : $t('Désactivé') }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>

          <div v-if="form.type_prix === 'fixe'">
         
            <div class="row">
              <div class="col-12">
                <b-form-group :label="$t('Prix par Cumac ')">
                  <b-form-input v-model="form.prix_cumac_classique" type="number" step="0.01" />
                  <div v-if="erreurlist.prix_cumac_classique" class="error-message">
                    <ul v-if="Array.isArray(erreurlist.prix_cumac_classique)">
                      <span v-for="(e, index) in erreurlist.prix_cumac_classique" :key="index">
                        {{ e }}
                      </span>
                    </ul>
                    <span v-else>{{ erreurlist.prix_cumac_classique }}</span>
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>
          
          <div v-if="errorS" class="error-message mt-2">
            {{ errorS }}
          </div>
        </div>
      </b-form>

      <template #modal-footer>
        <div class="double">
          <b-button variant="danger" @click="showModal = false">
            {{ $t("CANCEL") }}
          </b-button>
          <b-button variant="success" @click="saveOperation">
            {{ $t("SAVE") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Modal Delete -->
    <b-modal 
      v-model="showDeleteModal" 
      :title="$t('Confirmer la suppression')"
    >
      <p>{{ $t("Êtes-vous sûr de vouloir supprimer cette configuration ?") }}</p>
      
      <template #modal-footer>
        <b-button variant="secondary" @click="showDeleteModal = false">
          {{ $t("Annuler") }}
        </b-button>
        <b-button variant="danger" @click="deleteOperation">
          {{ $t("Supprimer") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(["getTabs", "getOnlineUser", "getAllEntitesExternes", "getdevisMonoFiche", "getAllConfigurations", "getLoadingConfiguration"]),
    isSuperAdmin() {
      return this.getOnlineUser?.role === "user.super-admin";
    },
  },
  data() {
    return {
      showModal: false,
      showDeleteModal: false,
      isEdit: false,
      selectedOperation: null,
      selectedTypeDevis: [],
      errorS: null,
      erreurlist: {},
      form: {
        type: "",
        label: "",
        version: "",
        volume_cumac: null,
        date_debut: "",
        date_fin: "",
        type_prix: "pourcentage",
        active: true,
        prix_cumac_precaire: null,
        prix_cumac_classique: null
      },
    
      typePrixOptions: [
        { value: "pourcentage", text: "Pourcentage" },
        { value: "fixe", text: "Fixe" }
      ],
      typeDevisOptions: [
        { value: "BAR-EN-101", text: "BAR-EN-101 - Isolation combles" },
        { value: "BAR-EN-102", text: "BAR-EN-102 - Isolation murs" },
        { value: "BAR-EN-103", text: "BAR-EN-103 - Isolation plancher" },
        { value: "BAR-EN-104", text: "BAR-EN-104 - Fenêtre ou porte-fenêtre complète avec vitrage isolant" },
        { value: "BAR-TH-127", text: "BAR-TH-127 - Ventilation mécanique simple flux hygroréglable" },
        { value: "BAR-TH-148", text: "BAR-TH-148 - Chauffe-eau thermodynamique à accumulation" },
        { value: "BAR-TH-161", text: "BAR-TH-161 - Isolation de points singuliers d'un réseau" },
        { value: "BAR-TH-171", text: "BAR-TH-171 - Pompe à chaleur de type air/eau" },
        { value: "BAR-TH-129", text: "BAR-TH-129 - Pompe à chaleur de type air/air" },
        { value: "BAR-TH-101", text: "BAR-TH-101 - Chauffe-eau" },
        { value: "BAR-TH-143", text: "BAR-TH-143 - Système solaire" },
        { value: "BAT-TH-142", text: "BAT-TH-142 - Système de déstratification d’air" }
      ]
    };
  },
  async mounted() {
    console.log('Component mounted, loading configurations...');
    await this.loadConfigurations();
    console.log('getAllConfigurations after load:', this.getAllConfigurations);
  },
  methods: {
    async loadConfigurations() {
      try {
        const entityId = this.$route.query.entityId;
        console.log('Loading configurations for entityId:', entityId);
        await this.$store.dispatch('allConfigurations', {
          entite_externe_id: entityId
        });
        console.log('Configurations loaded, getAllConfigurations:', this.getAllConfigurations);
      } catch (error) {
        console.error('Erreur lors du chargement des configurations:', error);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    
    goToPrecarite(operation) {
      console.log('goToPrecarite called with operation:', operation);
      const entityId = this.$route.query.entityId;
      const queryParams = { 
        entityId: entityId,
        configId: operation.id
      };
      
      console.log('Navigating to Precarites with queryParams:', queryParams);
      
      // Si super-admin, ajouter l'ID de l'entreprise de l'entité externe
      if (this.isSuperAdmin && entityId) {
        const entity = this.getAllEntitesExternes.find(e => e.id == entityId);
        if (entity && entity.entreprise_id) {
          queryParams.entrepriseId = entity.entreprise_id;
        }
      }
      
      this.$router.push({
        path: '/Precarites',
        query: queryParams
      });
    },
    
    openCreateModal() {
      this.isEdit = false;
      this.resetForm();
      this.errorS = null;
      this.erreurlist = {};
      this.showModal = true;
    },
    
    openEditModal(operation) {
      this.isEdit = true;
      this.selectedOperation = operation;
      this.errorS = null;
      this.erreurlist = {};
      
      // Copier les données et formater les dates
      this.form = { 
        ...operation,
        date_debut: this.formatDateForInput(operation.date_debut),
        date_fin: this.formatDateForInput(operation.date_fin)
      };
      
      // Initialiser le multiselect avec les valeurs existantes
      if (operation.type && Array.isArray(operation.type)) {
        this.selectedTypeDevis = this.typeDevisOptions.filter(option => 
          operation.type.includes(option.value)
        );
      } else {
        this.selectedTypeDevis = [];
      }
      
      this.showModal = true;
    },
    
    resetForm() {
      this.form = {
        type: "",
        label: "",
        version: "",
        volume_cumac: null,
        date_debut: "",
        date_fin: "",
        type_prix: "pourcentage",
        active: true,
        prix_cumac_precaire: null,
        prix_cumac_classique: null
      };
      this.selectedTypeDevis = [];
      this.errorS = null;
      this.erreurlist = {};
    },
    
    async saveOperation() {
      this.errorS = null;
      this.erreurlist = {};
      
      try {
        // Convertir les sélections multiselect en array de valeurs
        this.form.type = this.selectedTypeDevis.map(item => item.value);
        
        // Ajouter l'ID de l'entité externe depuis les query params
        const entityId = this.$route.query.entityId;
        if (entityId) {
          this.form.entite_externe_id = entityId;
        }
        
        // S'assurer que l'ID est présent en mode édition
        if (this.isEdit && this.selectedOperation && this.selectedOperation.id) {
          this.form.id = this.selectedOperation.id;
        }
        
        // Console log du payload
        console.log('Payload pour Modifier Barème CEE:', this.form);
        
        if (this.isEdit) {
          await this.$store.dispatch('editConfiguration', this.form);
        } else {
          await this.$store.dispatch('storeConfiguration', this.form);
        }
        
        this.showModal = false;
        this.resetForm();
        await this.loadConfigurations();
      } catch (error) {
        console.error('Erreur lors de la sauvegarde:', error);
        // Ignorer l'erreur et fermer le modal
        this.showModal = false;
        this.resetForm();
        await this.loadConfigurations();
      }
    },
    
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    
    confirmDelete(operation) {
      this.selectedOperation = operation;
      this.showDeleteModal = true;
    },
    
    async deleteOperation() {
      try {
        await this.$store.dispatch('deleteConfiguration', this.selectedOperation);
        this.showDeleteModal = false;
        await this.loadConfigurations();
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
        this.showDeleteModal = false;
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR');
    },
    
    formatDateForInput(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    },
    
    getLimitText(count) {
      return `+${count} ${count === 1 ? 'autre' : 'autres'}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.button-succes-style {
  margin: 0 2px;
}

.content {
  & p {
    font-size: 12px;
    font-weight: 500;
    padding: 3px 0;
    margin: 0;
  }
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

body {
  background: #fafdff;
}

.filtre {
  display: flex;
  align-items: center;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}

::v-deep .modal-content {
  background-color: white !important;
}

::v-deep .modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
}

::v-deep .modal-body .card {
  overflow: visible;
}

::v-deep .card .row {
  margin-bottom: 0;
}

::v-deep .card .form-group {
  margin-bottom: 0;
}

::v-deep .card .b-form-group {
  margin-bottom: 0;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.error-message ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.error-message span {
  display: block;
}

::v-deep .multiselect-operations {
  .multiselect__tags {
    min-height: 42px;
    max-height: 42px;
    height: 42px;
    padding: 5px 40px 0 8px;
    overflow: hidden;
    border: 1px solid #b5b5b5;
    border-radius: 5px;
  }

  .multiselect__tag {
    margin: 2px 4px 2px 0;
    background: #34c38f;
    color: #fff;
    border-radius: 3px;
    padding: 3px 8px;
    font-size: 12px;
    max-width: calc(50% - 4px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }

  .multiselect__tag-icon {
    color: #fff;
    margin-left: 4px;
    
    &:hover {
      background: #2aa876;
      border-radius: 3px;
    }
    
    &:after {
      color: #fff;
    }
  }

  .multiselect__input,
  .multiselect__single {
    margin: 0;
    padding: 0;
    min-height: 20px;
    line-height: 20px;
    font-size: 13px;
  }

  .multiselect__placeholder {
    padding-top: 6px;
    margin-bottom: 0;
    color: #999;
    font-size: 13px;
  }

  .multiselect__content-wrapper {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #b5b5b5;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  }

  .multiselect__content {
    max-height: 300px;
  }

  .multiselect__option {
    padding: 8px 12px;
    font-size: 13px;
    min-height: 36px;
    line-height: 20px;
    
    &:hover {
      background: #34c38f;
      color: #fff;
    }
    
    &--selected {
      background: #e9ecef;
      font-weight: 500;
      
      &:hover {
        background: #34c38f;
        color: #fff;
      }
    }
    
    &--highlight {
      background: #34c38f;
      color: #fff;
    }
  }

  .multiselect__limit {
    margin: 2px 4px 2px 0;
    background: #6472b3;
    color: #fff;
    border-radius: 3px;
    padding: 3px 8px;
    font-size: 12px;
    display: inline-block;
    font-weight: 500;
  }
}
</style>